import { useMemo, useState } from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { HELP } from "@/content/help";
import { DISCLAIMER } from "@/content/legalTerms";
import { Rich } from "@/components/info/DocRenderer";

const norm = (s) => s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

export const HelpCenter = () => {
  const [q, setQ] = useState("");
  const cats = useMemo(() => {
    const n = norm(q.trim());
    if (!n) return HELP;
    return HELP.map((c) => ({ ...c, articles: c.articles.filter(([t, a]) => norm(`${c.title} ${t} ${a}`).includes(n)) }))
      .filter((c) => c.articles.length);
  }, [q]);
  return (
    <div className="space-y-8">
      <p className="text-base text-muted-foreground">Guides pratiques pour utiliser Safe Start sur le terrain et en administration.</p>
      <div className="relative">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher dans l'aide (ex. STOP, hors ligne, conflit)"
          className="pl-9" data-testid="help-search-input" aria-label="Rechercher dans l'aide" />
      </div>
      {!q && (
        <nav aria-label="Catégories" className="flex flex-wrap gap-2" data-testid="help-categories">
          {HELP.map((c) => (
            <a key={c.id} href={`#${c.id}`} data-testid={`help-cat-${c.id}`}
              onClick={(e) => { e.preventDefault(); document.getElementById(c.id)?.scrollIntoView({ behavior: "smooth" }); }}
              className="rounded-full border border-border px-3 py-1 text-sm text-muted-foreground transition-colors hover:border-amber-500 hover:text-amber-500">{c.title}</a>
          ))}
        </nav>
      )}
      {cats.length === 0 && <p data-testid="help-no-result" className="text-sm text-muted-foreground">Aucun article ne correspond à « {q} ».</p>}
      {cats.map((c) => (
        <section key={c.id} id={c.id} className="scroll-mt-6" data-testid={`help-section-${c.id}`}>
          <h2 className="mb-2 font-heading text-lg font-semibold">{c.title}</h2>
          <Accordion type="multiple" className="rounded-lg border border-border px-4">
            {c.articles.map(([t, a], i) => (
              <AccordionItem key={t} value={t} className={i === c.articles.length - 1 ? "border-b-0" : ""}>
                <AccordionTrigger data-testid={`help-article-${c.id}-${i}`} className="text-left text-sm font-medium">{t}</AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-foreground/90"><Rich text={a} /></AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </section>
      ))}
      <p className="rounded-lg border border-amber-500/50 bg-amber-500/10 p-4 text-sm" data-testid="help-disclaimer">{DISCLAIMER}</p>
    </div>
  );
};
